"use strict";

define('components/filter_bar/table/bulk_edit',['components/ajax'], function(ajax) {
    var bulkEditComponent = {
        initWithContext: function(context) {
            var editButton = context.buttonbarNode.find('.selection-edit-bulk button');
            bulkEditComponent._initBulkButtonClick(context, editButton);

            var manageContactGroupsBulkButton = context.buttonbarNode.find(
                '.selection-manage-contact-groups-bulk button');
            bulkEditComponent._initBulkButtonClick(context, manageContactGroupsBulkButton);

            var deleteButton = context.buttonbarNode.find(
                '.selection-delete-bulk button');
                bulkEditComponent._initBulkButtonClick(context, deleteButton);
        },

        _initBulkButtonClick: function(context, button) {
            button.click(function(e) {
                var self = $(this);
                var objectIds = context.tableFilterBarData.tableInstance.getSelectedObjectIds();

                // The csrf_token will be added in the ajax call below.
                var content = new FormData();
                content.append("object_ids", objectIds);    // comma-separated IDs.

                self.prop('disabled', true);
                ajax(button.data('url'), {formData: content});
                $('#small-modal').one('hidden.bs.modal', function(e) {  // We assume that a dialog is always used.
                    self.prop('disabled', false);
                });

            });
        }
    };

    return bulkEditComponent;
});
